var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"desktop:absolute desktop:inset-0"},[_c('div',{class:`banner_wrapper move-${_setup.props.direction}`,style:(_setup.banner
        ? `background-image: url(${_setup.banner?.uri})`
        : 'background-image: url(/banner_mb.jpg)')}),_c('div',{staticClass:"desktop:hidden banner_mobile_wrapper w-full"},[_c('img',{attrs:{"src":_setup.banner_mobile?.uri || '/banner_mb.jpg'}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }